import type {DataListColumn, DataListResolved, PrintoutDataListAttrs} from "./printoutDataListOptions";

interface DataListLayout {
    columns: DataListColumn[];
    rowGroupLabels: string[];
}

export const getDataListLayout = (
    attrs: PrintoutDataListAttrs,
    resolved: DataListResolved | null,
): DataListLayout => {
    const ungrouped = {columns: attrs.columns, rowGroupLabels: []};
    if (attrs.columns.length < 2) return ungrouped;

    if (attrs.source !== "reservationMealPeriods" || !resolved) return ungrouped;

    const dateColumn = attrs.columns.find(column => (
        column.variableKey === "resStartDate" || column.variableKey === "resMealStartDate"
    ));
    if (!dateColumn) return ungrouped;

    const dates = resolved.items.map(item => item[dateColumn.id]?.trim() ?? "");
    // Keep the date column for a single day or incomplete dates, so no information disappears.
    if (dates.some(date => !date || date === "-") || new Set(dates).size < 2) return ungrouped;

    return {
        columns: attrs.columns.filter(column => column.id !== dateColumn.id),
        // Preserve the source order, including a new heading if a date occurs again later.
        rowGroupLabels: dates.map((date, index) => date === dates[index - 1] ? "" : date),
    };
};
